export default __webpack_public_path__ + "static/media/trip-adv.9849485e.png";